import pluralize from 'pluralize';

const count = (value, isShort) => {
  if (isShort) {
    return `#${value}`;
  }

  return pluralize('service', value, true);
};

export default count;
